import React, { useState, useEffect } from "react";
import { httpGetSellerCentralReports } from "../../service/httpClient";
import { PowerBIEmbed } from "powerbi-client-react";
import "powerbi-report-authoring";
import "./SellerReports.css";
import {
  ENABLED_FLAG,
  SELLER_REPORTS_LOAD_ERROR,
  SELLER_REPORTS_NOT_DISPLAY,
} from "../../constants/Constants";
import { getUserRolePermission } from "../../utils/rolePermissionAccess";
import * as RolePermissionConstants from "../../constants/RolePermissionConstants";
import PageNotFound from "../Routes/PageNotFound";
import { getDisableEnableConfig } from "../VendorOnboarding/OnboardingHelper";
import { useVendorProfileLoader } from "../Common/CustomHooks/useVendorProfileLoader";
import ErrorContainer from "../Common/Errors/ErrorContainer";

const Reports = () => {
  useVendorProfileLoader();
  const [reportsAvailable, setReportsAvailable] = useState("");
  const [reportsDisplayErrorMsg, setReportsDisplayErrorMsg] = useState("");
  const [sellerHubConfigValue, setSellerHubConfigValue] = useState("");
  const [sellerReportConfig, setReportConfig] = useState({
    type: "report",
    embedUrl: null,
    tokenType: 1,
    accessToken: null,
    settings: null,
  });

  const eventHandlersMap = new Map([
    ["loaded"],
    ["rendered"],
    [
      "error",
      (event) => {
        if (event) {
          setReportsDisplayErrorMsg(SELLER_REPORTS_LOAD_ERROR);
        }
      },
    ],
  ]);

  const reportsSignIn = () => {
    let reportConfig;
    httpGetSellerCentralReports()
      .then((response) => {
        setReportsAvailable(response?.data?.displaySeller);
        reportConfig = response?.data;
        response?.data?.displaySeller &&
          setReportConfig({
            ...sellerReportConfig,
            embedUrl: reportConfig?.embedUrl,
            accessToken: reportConfig?.accessToken,
          });
        if (!response?.data?.displaySeller) {
          setReportsDisplayErrorMsg(SELLER_REPORTS_NOT_DISPLAY);
        }
      })
      .catch((error) => {
        setReportsDisplayErrorMsg(SELLER_REPORTS_NOT_DISPLAY);
        console.log(error);
      });
  };

  useEffect(() => {
    const pathname = window.location.pathname;
    if (
      pathname.includes("/reports") &&
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_SELLER_CENTRAL_REPORTS,
        RolePermissionConstants.ALL
      ) === RolePermissionConstants.EDIT
    ) {
      reportsSignIn();
    }
    getDisableEnableConfig("sellerCentral", (response) => {
      setSellerHubConfigValue(response);
    });
  }, []);

  return (
    <>
      {sellerHubConfigValue && (
        <>
          {getUserRolePermission(
            RolePermissionConstants.VENDORPLATFORM_SELLER_CENTRAL_REPORTS,
            RolePermissionConstants.ALL
          ) === RolePermissionConstants.EDIT &&
          sellerHubConfigValue === ENABLED_FLAG ? (
            reportsAvailable && !reportsDisplayErrorMsg ? (
              <PowerBIEmbed
                embedConfig={sellerReportConfig}
                eventHandlers={eventHandlersMap}
                cssClassName={"report-style-class"}
              />
            ) : (
              reportsDisplayErrorMsg && (
                <div className="reportsNotAvailable">
                  <ErrorContainer
                    errorMsg={reportsDisplayErrorMsg}
                    errorStatus={true}
                    errorStyle="errorMessage"
                  />
                </div>
              )
            )
          ) : (
            <PageNotFound />
          )}
        </>
      )}
    </>
  );
};

export default Reports;
